import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(ScrollSmoother);

// ScrollSmoother.create({
// 	content: '#app',
// 	smooth: 0.5, // how long (in seconds) it takes to "catch up" to the native scroll position
// 	effects: true, // looks for data-speed and data-lag attributes on elements
// 	// smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// });

const defaultIntensity = 10;

function getIntensity(element) {
	const classes = element.className.split(' ');
	const parallaxClass = classes.find(cls => /^parallax-\d+$/.test(cls));
	if (!parallaxClass) return defaultIntensity / 100;
	const intensity = parseInt(parallaxClass.split('-')[1]);
	return (isNaN(intensity) ? defaultIntensity : intensity) / 100;
}

export function setupParallaxElements() {
	// Get all elements with .parallax class
	const parallaxElements = document.querySelectorAll('.parallax');

	// Loop through each element
	parallaxElements.forEach(parallaxElement => {
		// Create a tween for the image
		gsap.to(parallaxElement, {
			scrollTrigger: {
			  trigger: parallaxElement,
			  start: "top bottom", // Start when element's top hits bottom of viewport
			  end: "bottom top",   // End when element's bottom hits top of viewport
			  scrub: true,         // Smooth scrubbing effect
			  onUpdate: (self) => {
				// Calculate the center point
				const elementRect = parallaxElement.getBoundingClientRect();
				const elementCenter = elementRect.top + elementRect.height / 2;
				const windowCenter = window.innerHeight / 2;

				// Calculate distance from center (in pixels)
				const distanceFromCenter = elementCenter - windowCenter;

				// Apply the translation
				gsap.set(parallaxElement, {
				  y: distanceFromCenter * getIntensity(parallaxElement)
				});
			  }
			}
		  });
	});
}

export function setupParallaxElementOverflow(repeat = false) {
	// Get all elements with .parallax class
	const parallaxElements = document.querySelectorAll('.parallax');

	// Loop through each element
	parallaxElements.forEach(parallaxElement => {
		// Calculate the center point
		const elementRect = parallaxElement.getBoundingClientRect();
		const elementCenter = window.innerHeight + elementRect.height / 2;
		const windowCenter = window.innerHeight / 2;

		// Calculate distance from center (in pixels)
		const distanceFromCenter = elementCenter - windowCenter;

		const overflowMax = distanceFromCenter * getIntensity(parallaxElement);
		parallaxElement.style.setProperty('--parallax-overflow', `${overflowMax}px`);
	});

	if (repeat) {
		window.requestAnimationFrame(() => setupParallaxElementOverflow());
	}
}

